import React from "react";
import { Stat } from "../sample.data";
import { getVisibleSortedItems } from "../utils";

interface StatsGridProps {
  stats: Stat[];
}

export const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  const visibleStats = getVisibleSortedItems(stats);

  if (visibleStats.length === 0) return null;

  return (
    <div className="mt-6 grid grid-cols-4 gap-4 md:w-[480px]">
      {visibleStats.map((stat) => (
        <div key={stat.id} className="card-apple px-4 py-3 text-center">
          <div className="text-xl font-semibold">{stat.value}</div>
          <div className="text-xs text-secondary">{stat.label}</div>
          {stat.description && (
            <div className="text-xs text-tertiary mt-1">{stat.description}</div>
          )}
        </div>
      ))}
    </div>
  );
};
